import React from "react";
import { FormFeedback } from "reactstrap";
import { arrayMove } from "react-sortable-hoc";

import SortableList from "./SortList";

import "./List.css";

class List extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      items: [""]
    };
    this.remove = this.remove.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  
  remove = index => {
    const array = this.state.items;
    const confirm = window.confirm(
      "Are you sure you want to remove this item?"
    );
    if (confirm) {
      array.splice(index, 1);
      this.setState({ items: array });
      this.props.input.onChange(array);
    }
  };
  
  handleChange(e, index) {
    e.persist();
    const items = [...this.state.items];
    items[index] = e.target.value;
    this.setState({ items });
    this.props.input.onChange(items);
  }
  
  onSortEnd = ({ oldIndex, newIndex }) => {
    const itemsToMove = [...this.state.items];
    const itemsIn = arrayMove(itemsToMove, oldIndex, newIndex);
    this.setState({
      items: itemsIn
    });
    this.props.input.onChange(this.state.items);
  };
  
  addNewRow = () => {
    const items = this.state.items;
    items.push("");
    this.setState({ items });
  };
  
  componentWillMount() {
    const items = [...this.props.input.value];
    this.setState({
      items
    });
  }
  
  render() {
    const {
      canRemove,
      canAdd,
      itemsDisabled
    } = this.props;
    
    return (
      <div>
        <SortableList
          items={this.props.input.value ? this.props.input.value : [""]}
          onSortEnd={this.onSortEnd}
          removeItem={this.remove}
          pressDelay={100}
          canRemove={canRemove}
          canAdd={canAdd}
          itemsDisabled={itemsDisabled}
          axis="y"
          helperClass="dragging"
          hideSortableGhost={true}
          lockToContainerEdges={true}
          addNewRow={this.addNewRow}
          handleChange={this.handleChange}
        />
        {this.props.meta.touched &&
        this.props.meta.error && (
          <FormFeedback style={{ display: "block" }}>
            {this.props.meta.error}
          </FormFeedback>
        )}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/containers/CruiseLines/components/List.jsx